import { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/utils/Button";
import { useForm } from "react-hook-form";
import moment from "moment";
import Calendar2LineIcon from "remixicon-react/Calendar2LineIcon";
import DatePicker from "react-datepicker";
import CardLayout from "../../components/utils/CardLayout";
import SideButtons from "../../components/utils/SideButtons";
import SearchBar from "../../components/utils/SearchBar";
import Table from "../../components/utils/Table";
import DataTable from "../../components/utils/DataTableClient";
import Modal from "../../components/utils/Model";
import Alert from "../../components/utils/Alert";
import EyeFill from "remixicon-react/EyeFillIcon";
import MDNForm from "./MDNForm";
import MDNSwapActions from "../../redux/MDNSwap/actions";
import networkActions from "../../redux/network/actions";
import shortCodeActions from "../../redux/shortCodeData/actions";
import authActions from "../../redux/auth/actions";
import Tag from "../../components/utils/Tag";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import DownloadCloud2sLineIcon from "remixicon-react/DownloadCloud2LineIcon";

import {
  convertDateTimeToRequiredFormatTZ,
  isAdmin,
  isAdminAgent,
  isDealer,
} from "../../helpers/commonFunction";

// ACTION DESTRUCTURING

const {
  createMdnSwapRequest,
  getMdnSwapRequest,
  resetMdnSwapMessage,
  getMdnSwapBatchTransactionIdRequest,
} = MDNSwapActions;

const { getActiveNetwork } = networkActions;
const { getShortCode } = shortCodeActions;
const { getUserDataByToken } = authActions;

// COMPONENT
function MDNSwap() {
  const dispatch = useDispatch();
  const datePickerRef = useRef(null);
  const datePickerRef2 = useRef(null);
  const [pageNo, setPageNo] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [toDate, setToDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(
    new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
  );
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [batchDetails, setBatchDetails] = useState([]);
  const [openViewModel, setOpenViewModel] = useState(false);
  const [selectedBatchID, setSelectedBatchID] = useState("");
  const [selectedBatchData, setSelectedBatchData] = useState(null);

  const {
    createMdnSwapLoading,
    createMdnSwapMessage,
    createMdnSwapError,
    getMdnSwapLoading,
    getMdnSwapData,
    bulkMDNSwapResultByBatchID,
    bulkMDNSwapResultByBatchIDLoading,
  } = useSelector((state) => state.mdnSwap);
  const { getRechargeReuestList, getRechargeReuestLoading } = useSelector(
    (state) => state.rechargeRequest,
  );

  const { tokenData } = useSelector((state) => state.auth);
  const { networkResult } = useSelector((state) => state.network);
  const { shortCodeResult } = useSelector((state) => state.shortCode);
  const { list: aggregatorList } = useSelector((state) => state.aggregator);
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const { register, handleSubmit, getValues } = useForm({
    defaultValues: {
      networkID: "",
      MSISDN: "",
      statusID: "0",
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
      toDate: moment(toDate).format("YYYY-MM-DD"),
    },
  });

  const searchValues = getValues();
  const searchData = useMemo(() => {
    return {
      ...searchValues,
      toDate: moment(toDate).format("YYYY-MM-DD"),
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
    };
  }, [searchValues, toDate, fromDate]);

  useEffect(() => {
    dispatch(getActiveNetwork());
    dispatch(getMdnSwapRequest(searchData));
    dispatch(
      getShortCode({
        tableName: "activationrequest",

        fieldName: "RequestStatus",
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (createMdnSwapError !== null && createMdnSwapError !== undefined) {
      displayAlert(createMdnSwapError, "alert-danger");
    }

    if (createMdnSwapMessage !== null && createMdnSwapMessage !== undefined) {
      displayAlert(createMdnSwapMessage, "alert-success");
      dispatch(getUserDataByToken());

      // Refresh table
      dispatch(getMdnSwapRequest(searchData));
      console.log(getMdnSwapData);
    }
  }, [createMdnSwapError, createMdnSwapMessage, dispatch]);

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
    dispatch(resetMdnSwapMessage());
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
  };

  // SEARCH
  const handleFilterChange = (value) => {
    setFilterText(value);
  };

  const onSubmit = (data) => {
    const searchRequest = {
      ...data,

      toDate: moment(toDate).format("YYYY-MM-DD"),

      fromDate: moment(fromDate).format("YYYY-MM-DD"),
    };
    dispatch(getMdnSwapRequest(searchRequest));
  };

  // OPEN MDN SWAP FORM
  const handleMDNSwapForm = () => {
    setPageNo(1);
  };

  const handleRechargeFormBack = () => {
    setPageNo(0);
  };

  // CREATE MDN SWAP
  const handleCreateMdnSwap = (formData) => {
    dispatch(createMdnSwapRequest(formData));
  };

  // BATCH CLICK
  const handleBatchClick = (e, row) => {
    e.preventDefault();
    setSelectedBatch(row);
    const details =
      row?.details || row?.detailData || row?.Items || row?.records || [];

    if (Array.isArray(details)) {
      setBatchDetails(details);
    } else {
      setBatchDetails([]);
    }

    setShowBatchModal(true);
  };

  // CLOSE MODAL
  const closeBatchModal = () => {
    setShowBatchModal(false);

    setSelectedBatch(null);

    setBatchDetails([]);
  };

  const handleShowTransactionDetails = (item) => {
    alertCancel();
    setOpenViewModel(true);
    const batchID = item.batchTransactionId;
    setSelectedBatchID(batchID);
    const newData = {
      batchID: batchID,
    };
    setSelectedBatchData(newData);
    dispatch(getMdnSwapBatchTransactionIdRequest(newData));
  };

  // MAIN TABLE COLUMNS
  const columns = [
    {
      name: "#",
      selector: (row) => row.id,
      sortable: true,
      width: "80px",
      center: true,
    },
    {
      name: "REFERENCE",
      cell: (row) => (
        <div className="flex flex-col py-2">
          <div>
            <strong>Batch TXNID:</strong>{" "}
            <span
              onClick={() => handleShowTransactionDetails(row)}
              style={{
                cursor: "pointer",
                color: "rgb(0, 76, 164)",
                fontWeight: 600,
                textDecoration: "underline",
              }}
              title="view details"
            >
              {row.batchTransactionId || "-"}
            </span>
          </div>
          <div className="my-2">
            <strong>Dealer Name:</strong> {row.dealername || "-"}
          </div>
          <div>
            <strong>Dealer Email:</strong> {row.dealeremail || "-"}
          </div>
        </div>
      ),
      width: "300px",
    },
    {
      name: "NETWORK",
      selector: (row) => row.network,
      width: "150px",
    },
    {
      name: "QUANTITY",
      cell: (row) => (
        <div style={{ display: "flex", gap: "6px" }}>
          <Tag color="badge-success" title={row.totalprocessed} />
          <Tag color="badge-danger" title={row.totalcancelled} />
          <Tag color="badge-secondary" title={row.quantity} />
        </div>
      ),
      width: "140px",
    },
    ,
    {
      name: "STATUS",
      cell: (row) => {
        switch (row.status) {
          case "Completed":
            return <Tag color="badge-success" title="Completed" />;
          case "Failed":
            return <Tag color="badge-danger" title="Failed" />;
          case "Partial":
          default:
            return <Tag color="badge-secondary" title="Partial" />;
        }
      },
    },

    {
      name: "SUBMITTED DATE",

      selector: (row) => row.submitteddate,

      width: "180px",
    },

    {
      name: "ACTION",
      selector: (row) => row.action,
      cell: (row) => (
        <Link to="#" onClick={() => handleShowTransactionDetails(row)}>
          <span title="View">
            <EyeFill size="1.2em" style={{ color: "#294c28eb" }} />
          </span>
        </Link>
      ),
    },
  ];

  // FILTER
  const filteredItems =
    Array.isArray(getMdnSwapData) && getMdnSwapData.length > 0
      ? getMdnSwapData.filter((item) => {
          if (typeof filterText !== "string" || typeof item !== "object")
            return false;
          // Check if any value in the object contains the filterText
          return Object.values(item).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(filterText.toLowerCase()),
          );
        })
      : [];
  const data = Array.isArray(filteredItems)
    ? filteredItems.map((item, index) => ({
        id: index + 1,
        batchTransactionId: item.BatchTransactionId,
        dealername: item.DealerName,
        dealeremail: item.ContactEmailID,
        network: item.NetworkName,
        totalprocessed: item.TotalSuccessTxn || 0,
        totalcancelled: item.TotalFailedTxn || 0,
        quantity: item.TotalTxn || 0,
        submitteddate:
          item.RequestedDtTm !== null
            ? convertDateTimeToRequiredFormatTZ(item.RequestedDtTm)
            : "",
        status: item.Status,
      }))
    : [];

  // DATE PICKER
  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const openDatePicker2 = () => {
    if (datePickerRef2.current) {
      datePickerRef2.current.setOpen(true);
    }
  };

  // MODAL COLUMNS
  const ModalColumns = [
    { displayName: "#", key: "key" },
    { displayName: "TRANSACTIONID", key: "transactionID" },
    { displayName: "SERIAL NUMBER", key: "serialNumber" },
    { displayName: "MSISDN", key: "mobileNumber" },
    { displayName: "NEW MSISDN", key: "newMsisdn" },
    { displayName: "AREA CODE", key: "zipCode" },
    { displayName: "STATUS", key: "status" },
    { displayName: "REMARK", key: "remark" },
  ];
  // MODAL DATA
  const dataSource =
    bulkMDNSwapResultByBatchID &&
    bulkMDNSwapResultByBatchID.length > 0 &&
    bulkMDNSwapResultByBatchID.map((Item, key) => ({
      key: key + 1,
      transactionID: Item.TransactionID,
      serialNumber: Item.SerialNumber,
      mobileNumber: Item.MSISDN,
      newMsisdn: Item.NewMSISDN,
      zipCode: Item.Zipcode,
      networkName: Item.NetworkName,
      status: (
        <Tag
          color={
            Item.RequestStatus === 13
              ? "badge-danger"
              : Item.RequestStatus === 11
                ? "badge-warning"
                : Item.RequestStatus === 12
                  ? "badge-success"
                  : Item.RequestStatus === 32
                    ? "badge-secondary"
                    : Item.RequestStatus === 49
                      ? "badge-info"
                      : "badge-secondary"
          }
          title={Item.StatusDescription}
        />
      ),
      remark: Item.Remark,
    }));
  const closeBulkTxnModal = () => {
    setOpenViewModel(false);
    alertCancel();
  };
  const listDataModel =
    bulkMDNSwapResultByBatchID?.map((item, key) => ({
      "Sr. No": key + 1,
      "Transaction ID": item.TransactionID,
      "Serial Number": item.SerialNumber,
      MSISDN: item.MSISDN,
      "NEW MSISDN": item.NEWMSISDN,
      "Area Code": item.Zipcode,
      Status: item.StatusDescription,
      Remark: item.Remark,
    })) || [];

  const exportToCSVModal = async () => {
    if (listDataModel && listDataModel.length > 0) {
      const ws = XLSX.utils.json_to_sheet(listDataModel);
      const wb = {
        Sheets: { bulkPortinActivationList: ws },
        SheetNames: ["bulkPortinActivationList"],
      };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      await FileSaver.saveAs(data, "MDN_Swap_Report" + fileExtension);
    }
  };

  // RETURN
  return (
    <>
      {pageNo === 1 ? (
        <MDNForm
          back={handleRechargeFormBack}
          search={searchData}
          onSubmit={handleCreateMdnSwap}
          loading={createMdnSwapLoading}
        />
      ) : (
        <CardLayout title="MDN Swap">
          {/* SEARCH FORM */}

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-row">
              {/* NETWORK */}

              <div className="col-lg-2 col-md-4 mb-2">
                <label>Select Network</label>

                <select className="form-control" {...register("networkID")}>
                  <option value="">All</option>

                  {networkResult
                    ?.filter((item) => item.IsActive == 1 && item.ID == 4)
                    .map((item) => (
                      <option value={item.ID} key={item.ID}>
                        {item.NetworkName}
                      </option>
                    ))}
                </select>
              </div>

              {/* STATUS */}

              <div className="col-lg-2 col-md-4 mb-2">
                <label>Select Status</label>
                <select className="form-control" {...register("statusID")}>
                  <option value="0">All</option>
                  <option value="1">Completed</option>
                  <option value="2">Failed</option>
                  <option value="3">Partial</option>
                </select>
              </div>

              {/* FROM DATE */}

              <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                <label>From Date</label>

                <Calendar2LineIcon
                  onClick={openDatePicker}
                  size="1.5rem"
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "36px",
                    right: "12px",
                    zIndex: 1,
                  }}
                />

                <DatePicker
                  ref={datePickerRef}
                  selected={fromDate}
                  className="form-control"
                  onChange={(date) => setFromDate(date)}
                  dateFormat="yyyy-MM-dd"
                  showMonthDropdown
                  showYearDropdown
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              {/* TO DATE */}

              <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                <label>To Date</label>

                <Calendar2LineIcon
                  onClick={openDatePicker2}
                  size="1.5rem"
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "36px",
                    right: "12px",
                    zIndex: 1,
                  }}
                />

                <DatePicker
                  ref={datePickerRef2}
                  selected={toDate}
                  className="form-control"
                  onChange={(date) => setToDate(date)}
                  dateFormat="yyyy-MM-dd"
                  showMonthDropdown
                  showYearDropdown
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              {/* MSISDN */}

              <div className="col-lg-2 mb-2">
                <label>MSISDN</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter MSISDN"
                  {...register("MSISDN")}
                />
              </div>

              {/* SEARCH */}

              <div className="mt-4" id="main-btn-cdnq">
                <Button
                  title="Search"
                  style={{
                    minWidth: "80",
                  }}
                  buttonClass="ntn-search-cdn mt-1 btn-md "
                  id="searchbtn-swp"
                  buttonType="submit"
                />
              </div>
            </div>
          </form>

          <hr />

          {/* SEARCH BAR */}

          <div className="row mb-3">
            <div className="col-lg-3 col-md-6">
              <SearchBar
                onFilter={handleFilterChange}
                filterText={filterText}
              />
            </div>

            {isDealer(tokenData) && (
              <div className="col-lg-9 d-flex justify-content-end">
                <SideButtons title="MDN Swap" onClick={handleMDNSwapForm} />
              </div>
            )}
          </div>

          {/* ALERT */}

          {showAlert && (
            <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
          )}

          {/* TABLE */}

          <div id="activationRequestTable">
            <DataTable
              columns={columns}
              data={data}
              loading={getMdnSwapLoading}
              customStyles={{
                headRow: {
                  style: {
                    backgroundColor: "#FFF5F5",
                  },
                },

                headCells: {
                  style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                  },
                },
              }}
            />
          </div>
        </CardLayout>
      )}

      {/* ========================================
          BATCH DETAIL MODAL
      ======================================== */}

      <Modal
        showModal={openViewModel}
        title={"MDN Swap Details : "}
        subTitle={<span style={{ color: "#990404" }}>{selectedBatchID}</span>}
        onHide={() => closeBulkTxnModal()}
        width={1000}
        showFooter={false}
      >
        {showAlert && (
          <div className="mt-4">
            <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
          </div>
        )}
        <div className="d-flex justify-content-end mb-3">
          {listDataModel && listDataModel.length > 0 && (
            <Button
              onClick={exportToCSVModal}
              title="Export"
              icon={<DownloadCloud2sLineIcon size={15} />}
              style={{ minWidth: "120px" }}
              buttonClass="btn acti-export-btn-v acti-ex-btn font-weight-bold text-white"
            />
          )}
        </div>
        <Table
          columns={ModalColumns}
          loading={bulkMDNSwapResultByBatchIDLoading}
          data={dataSource}
          pagination={false}
        />
      </Modal>
    </>
  );
}

export default MDNSwap;
